import { useEffect, useRef } from "react";

// This prevents the screen from locking themselves when inactive
export const useWakeLock = (requestIfTrue: boolean, releaseIfTrue: boolean) => {
  const wakeLock = useRef<WakeLockSentinel>();

  useEffect(() => {
    if (requestIfTrue) {
      const requestWakeLock = async () => {
        wakeLock.current = await navigator.wakeLock.request("screen");
      };
      requestWakeLock();
    }
    if (releaseIfTrue && wakeLock.current) {
      const releaseWakeLock = async () => {
        await wakeLock.current?.release();
        wakeLock.current = undefined;
      };
      releaseWakeLock();
    }
  }, [requestIfTrue, releaseIfTrue]);
};
